/**
 * @module sticky-nav
 *
 * Adds classes for sticky navigation
 */

import { selectOne } from './utils/dom-utils';

export default function initStickyNav() {

  const SCROLL_CLASS = 'sticky-scroll';

  var logViewport = function () {
    const ELEM_STICKY_NAV = selectOne('.sticky-nav');
    if (!ELEM_STICKY_NAV) return;
    if (window.scrollY > 0) {
      ELEM_STICKY_NAV.classList.add(SCROLL_CLASS);
    } else {
      ELEM_STICKY_NAV.classList.remove(SCROLL_CLASS);
    }
  };

  logViewport();
  window.addEventListener('scroll', logViewport, false);

}
